import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


export interface UserEditorData {
  utilisateur : any;
}


@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss']
})

export class EditUserComponent implements OnInit {

  formUser !: FormGroup;


  constructor(public dialogRef: MatDialogRef<UserEditorData>, public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: UserEditorData,
  private builder: FormBuilder) {
   }

  ngOnInit(): void {
    if (this.data.utilisateur) {
      this.formUser = this.builder.group({
        login: [ {value: this.data.utilisateur.login, disabled: true}  ],
        nom: [ this.data.utilisateur.nom ],
        prenom: [ this.data.utilisateur.prenom ],
        pwd : [ this.data.utilisateur.pwd ]
      });
    }

    }


  public onSubmit() {
    console.log(this.formUser.value);
    this.dialogRef.close({user: this.formUser.value });
  }



}
